import React, { lazy } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Login from "../components/pages/login";
import PageNotFound from "../components/pages/pageNotFound";
// import AppLayout from "../components/appLayout";
import { Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Dashboard from "../components/pages/dashboard";
import { useEffect } from "react";
import { message } from "antd";
import AppLayout from "../components/appLayout";
import Meta from "../Meta";
import { useState } from "react";
import LogsTable from "../components/pages/falcon/logs/LogsTable";
const Users = lazy(() => import("../components/pages/users"));
const Epms = lazy(() => import("../components/pages/epms"));
const AP_Prohance = lazy(() => import("../components/pages/ap_prohance"));
const AP_ProhanceCondition = lazy(() =>
  import("../components/pages/ap_prohancecondition")
);
const AP_ManageJobs =  lazy(() => import("../components/pages/ap_manageJobs"));
const AP_Falcon = lazy(() => import("../components/pages/ap_falcon"));
const AP_FalconCondition = lazy(() =>
  import("../components/pages/ap_falconcondition")
);
const EpmsLogs = lazy(() => import("../components/pages/epmsLogs"));
const EpmsLogsDetail = lazy(() => import("../components/pages/epmsLogsDetail"));
const FalconLogs =lazy(()=>import("../components/pages/falcon/logs"));

const ProtectedRoutes = () => {
  let user = localStorage.getItem("authToken");
  return user ? <Outlet /> : <Navigate replace to="login" />;
};

const PublicRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<ProtectedRoutes />}>
          <Route                 
             path="/" element={<AppLayout/>}>
            <Route path="/">
              <Route index={true} element={<Epms />} />
            </Route>
            <Route path="/employee-master">
              <Route
                index={false}
                path="dashboard"
                element={<Dashboard />}
              ></Route>
              <Route index={false} path="snapshot" element={<Epms />} />
              <Route index={false} path="logs" element={<EpmsLogs />} />
              <Route
                index={false}
                path="logsDetail"
                element={<EpmsLogsDetail />}
              />
            </Route>
            <Route path="/auto-provisioning">
              <Route
                index={false}
                path="prohance"
                element={<AP_Prohance />}
              ></Route>
              <Route
                index={false}
                path="manage-jobs"
                element={<AP_ManageJobs />}
              ></Route>
              <Route
                index={false}
                path="prohance/:id"
                element={<AP_ProhanceCondition />}
              ></Route>
              <Route index={false} path="falcon" element={<AP_Falcon />}></Route>
              <Route
                index={false}
                path="falcon/:id"
                element={<AP_FalconCondition />}
              ></Route>
            </Route>
            <Route path="/falcon">
              <Route
                index={false}
                path="logs"
                element={<FalconLogs />}
              ></Route>
                 <Route
                index={false}
                path="logsDetails"
                element={<LogsTable />}
              ></Route>
            </Route>
          </Route>
          </Route>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
};
export default PublicRoutes;